import {getCurrentLoadings} from "redux-request-middleware/reducer";
import {IReduxAction} from "StateInterface";
import {
  isLoading,
  service,
  isRequestActionUnserved,
  cleanAction,
  cleanActionType,
} from "redux-request-middleware/utils";
export {postRequest, getRequest} from "redux-request-middleware/utils";

export type postAction = (body, error) => {
  type: string,
  [key: string]: any,
};

export interface IServiceAction<A, B extends Object, Q extends Object, E extends Object> extends IReduxAction<A> {
  type?: A;
  error?: object;
  response?: {
    statusCode?: number,
  };
  body?: any;
  payload?: {
    extra?: E,
    location?: {
      pathname?: string,
    },
    successAction?: postAction,
    failureAction?: postAction,
    service: {
      baseUrl: string,
      method: string,
      url: string,
      body?: B,
      qs?: Q,
      callback?: (error, response, body) => void,
      headers: object,
      json: boolean,
    },
  };
}

const successResponseCodes = [200, 201, 202, 203, 204];

const middleware = (store: {dispatch: (action: any) => void}) =>
  (next: (action: any) => void) =>
    (action: IServiceAction<any, any, any, any>) => {
      if (store && isRequestActionUnserved(action)) {
        if (!isLoading(getCurrentLoadings(), cleanAction(action))) {
          const options = action.payload.service;
          options.callback = (error, response, body) => {
            if (error || successResponseCodes.indexOf(response.statusCode) === -1) {
              store.dispatch({
                type: `${action.type}_FAILURE`,
                error,
                response,
                body,
                payload: action.payload,
              });
              if (action.payload.failureAction) {
                store.dispatch(action.payload.failureAction(body, error));
              }
            } else {
              store.dispatch({
                type: `${action.type}_SUCCESS`,
                error,
                response,
                body,
                payload: action.payload,
              });
              if (action.payload.successAction) {
                store.dispatch(action.payload.successAction(body, error));
              }
            }
          };
          service(options);
          next(action);
        } else {
          store.dispatch({
            type: `${cleanActionType(action.type)}_REDUNDENT`,
            action,
          });
          next(action);
        }
      } else {
        next(action);
      }
};

export default middleware;
